export interface IProfile {
  name: string;
  profileImageURL?: string;
}
